import moment from "moment-timezone";

const MESSAGE_TIMESTAMP = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/;

export const formatMessageTimestamp = (value, salonTimezone) => {
  if (typeof value !== "string") return "";
  const text = value.trim();
  // A date alone is not a message timestamp; do not invent a time for it.
  if (!MESSAGE_TIMESTAMP.test(text)) return "";

  // Message history stores UTC. Offset-free legacy responses must therefore be
  // parsed as UTC too; explicit ISO offsets are respected by moment.utc.
  const timestamp = moment.utc(text, moment.ISO_8601, true);
  if (!timestamp.isValid()) return "";

  const timezone = typeof salonTimezone === "string" && moment.tz.zone(salonTimezone)
    ? salonTimezone
    : "UTC";

  return timestamp.tz(timezone).format("DD MMM YYYY, h:mm A");
};
